<template>
    <div style="padding-top: 1rem;background-color: #f5f5f5">
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Activity area'"></navTitle>
        <div class="flex-container">
            <div class="flex-item">Active Code</div>
            <div class="flex-item"><input class="input" placeholder="Enter your code" v-model="exchange_code"/>
            </div>
            <div class="flex-item button1" @click="exchangeCode">Submit</div>
        </div>
        <div class="flex-container" @click="luckyAward">
            Lucky jackpot
        </div>
        <div class="flex-container" @click="$router.push({path: '/turntable'})">
            Turntable
        </div>
        <div class="flex-container">
            Stay tuned
        </div>
    </div>
</template>

<script>
    import navTitle from "@components/navTitle"
    import {exchange_code} from "@api/user"

    export default {
        name: "activityArea",
        components: {
            navTitle
        },
        data() {
            return {
                exchange_code: ''
            }
        },
        methods: {
            exchangeCode() {
                if (this.exchange_code === '') {
                    return this.$dialog.toast({mes: "Please fill in the exchange code"})
                }
                let that = this
                exchange_code({verification_code: that.exchange_code}).then(res => {
                    that.$dialog.success(res.msg);
                    // that.User();
                }).catch(res => {
                    that.$dialog.error(res.msg);
                })
            },
            luckyAward(){
                this.$router.push({path: '/lucky-award'})
            }
        }
    }
</script>

<style scoped>
    .flex-container {
        margin: 10px 1%;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: space-around;
        justify-content: space-around;
        background-color: #fff;
        width: 98%;
        padding: 8px 3px;
        border-radius: 5px;
    }

    .button1 {
        background: rgb(0, 195, 249);
        color: #fff;
        padding: 2px;
        border-radius: 5px;
    }
</style>